import { Dictionary, mapKeys } from 'lodash'

type Error = {
  name: string
  input?: string
  error?: string
}

/**
 * Takes the error output thrown by the Form component
 * and formats it to a dictionary of type Error or a JSON
 * formatted string
 * @param errorOutput error output thrown by Form
 * @param formFields the fields prop from the Form component
 * @param returnJson if true, return JSON formatted string
 * @returns Dictionary of Errors
 */
export const formatErrorKeys = (
  errorOutput: Error[],
  formFields: object,
  returnJson = false
): Dictionary<Error> | string => {
  const keys = mapKeys(errorOutput, value => value.name)
  for (const field in formFields) {
    if (keys.hasOwnProperty(field) && field !== 'password') {
      keys[field].input = formFields[field].value
    }
  }

  if (returnJson) {
    return JSON.stringify(keys)
  }

  return keys
}
